import Vue from 'vue'

const datetime = function (timestamp) {
  let d = new Date(parseInt(timestamp) * 1000)
  let yyyy = d.getFullYear()
  let mm = ('0' + (d.getMonth() + 1)).slice(-2)
  let dd = ('0' + d.getDate()).slice(-2)
  let hh = d.getHours()
  let min = ('0' + d.getMinutes()).slice(-2)
  let time = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + min
  return time
}

const datetimePoint = function (timestamp) {
  let d = new Date(parseInt(timestamp) * 1000)
  let yyyy = d.getFullYear()
  let mm = ('0' + (d.getMonth() + 1)).slice(-2)
  let dd = ('0' + d.getDate()).slice(-2)
  let hh = d.getHours()
  let min = ('0' + d.getMinutes()).slice(-2)
  let time = yyyy % 100 + '.' + mm + '.' + dd + ' ' + hh + ':' + min
  return time
}

const date = function (dateObj) {
  let d = dateObj
  let yyyy = d.getFullYear()
  let mm = ('0' + (d.getMonth() + 1)).slice(-2)
  let dd = ('0' + d.getDate()).slice(-2)
  let time = yyyy + '-' + mm + '-' + dd
  return time
}

const time = function (dateObj) {
  let d = dateObj
  let hh = d.getHours()
  let min = ('0' + d.getMinutes()).slice(-2)
  let time = hh + ':' + min
  return time
}

Vue.filter('datetime', datetime)
Vue.filter('datetimePoint', datetimePoint)
Vue.filter('date', date)
Vue.filter('time', time)



// WEBPACK FOOTER //
// ./src/filters.js